import Image from 'next/image';

import styled from '../../theme/styled-with-theme';
import { pxToRem } from '../../styles/utils';

import { Box } from '../Box';
import { Flexbox } from '../Flexbox';

export const BoxWithBorder = styled(Box)`
  border-top: ${({ theme }) => `1px solid ${theme.color.collapsibleBorder}`};

  &:last-child {
    border-bottom: ${({ theme }) =>
      `1px solid ${theme.color.collapsibleBorder}`};
  }
`;

export const ToggleWrapper = styled('div')`
  height: ${pxToRem(20)};
  width: ${pxToRem(20)};
`;

export const ToggleIcon = styled(Image, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})<{ isOpen: boolean }>`
  transform: ${({ isOpen }) => (isOpen ? 'rotate(45deg)' : 'none')};
  transition: 0.2s transform ease;
`;

export const ClickableFlexbox = styled(Flexbox)`
  cursor: pointer;
  transition: color 0.2s ease;
  &:hover {
    color: ${({ theme }) => theme.color.black};
  }
`;
